<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Request',
  }
</script>

<style scoped>
</style>